import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

import { noop } from '@src/shared/lib';
import React from 'react';

interface FormProps {
  children?: React.ReactNode;
  onSubmit?: () => void;
  sx?: SxProps<Theme>;
}

const Form = React.forwardRef<HTMLFormElement, FormProps>(
  ({ children, onSubmit = noop, sx }, ref) => {
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      e.stopPropagation();
      onSubmit();
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
      if (
        e.key !== 'Enter'
        || e.ctrlKey
        || e.metaKey
        || e.defaultPrevented
      ) {
        return;
      }

      const target = e.target as HTMLElement;
      if (target instanceof HTMLTextAreaElement || target.isContentEditable) {
        return;
      }

      e.preventDefault();
    };

    return (
      <Box
        ref={ref}
        sx={sx}
        component="form"
        onKeyDown={handleKeyDown}
        onSubmit={handleSubmit}
      >
        {children}
      </Box>
    );
  },
);

Form.displayName = 'Form';
export default Form;
